var N = Object.defineProperty;
var j = (l, e, c) => e in l ? N(l, e, { enumerable: !0, configurable: !0, writable: !0, value: c }) : l[e] = c;
var I = (l, e, c) => j(l, typeof e != "symbol" ? e + "" : e, c);
function F(l = 8, e = "", c = "") {
  const w = Math.random().toString(36).substr(2, l);
  return e + w + c;
}
var B = /* @__PURE__ */ ((l) => (l.SUCCESS = "1x00000000000000000000AA", l.FAIL = "2x00000000000000000000AB", l.SUCCESS_HIDE = "1x00000000000000000000BB", l.FAIL_HIDE = "2x00000000000000000000BB", l.SUCCESS_HIDE2 = "3x00000000000000000000FF", l))(B || {});
function z(l, e) {
  return document.querySelector(`script[src="${e}"]`) || Reflect.get(window, l) ? Promise.resolve() : new Promise((w, k) => {
    const r = document.createElement("script");
    r.src = e, document.body.appendChild(r), r.onload = () => {
      w();
    }, r.onerror = () => {
      k();
    };
  });
}
const f = "cloudflare_hide_instance", u = "cloudflare_hide_instance_key";
async function q(l) {
  var k;
  await z("turnstile", "https://challenges.cloudflare.com/turnstile/v0/api.js");
  const e = { ...l };
  delete e.id, delete e.wrapperClassname, delete e.onSuccess, delete e.onError, delete e.interactiveCallback, delete e.closeInteractiveCallback;
  const c = (k = window.turnstile) == null ? void 0 : k.render(l.id, {
    sitekey: l.siteKey,
    appearance: "interaction-only",
    size: l.size || "normal",
    ...e,
    callback: (r) => {
      var t, i;
      console.log("token", r);
      const s = (t = Reflect.get(window, f)) == null ? void 0 : t.callback;
      s == null || s(r), (i = l.onSuccess) == null || i.call(l, r);
    },
    "before-interactive-callback": () => {
      var r;
      (r = l.interactiveCallback) == null || r.call(l);
    },
    "after-interactive-callback": () => {
      var r;
      (r = l.closeInteractiveCallback) == null || r.call(l);
    },
    "error-callback": (r) => {
      var t, i;
      const s = (t = Reflect.get(window, f)) == null ? void 0 : t.errorCallback;
      s ? s(r) : (i = l == null ? void 0 : l.onError) == null || i.call(l, r);
    }
  }), w = {
    retry: (r) => {
      var s;
      return (s = window.turnstile) == null || s.reset(Reflect.get(window, u)), new Promise((t) => {
        const i = () => {
          Reflect.deleteProperty(w, "callback"), Reflect.deleteProperty(w, "errorCallback");
        }, n = (d) => {
          console.log("this is callback", d), i(), t(d);
        }, y = (d) => {
          var S;
          (S = r == null ? void 0 : r.onError) == null || S.call(r, d);
        };
        Reflect.set(w, "callback", n), Reflect.set(w, "errorCallback", y), Reflect.set(window, f, w), setTimeout(() => {
          var d;
          (d = window.turnstile) == null || d.execute(Reflect.get(window, u));
        }, 200);
      });
    },
    execute: () => new Promise((r, s) => {
      var y;
      const t = (d) => {
        n(), r(d);
      }, i = (d) => {
        n(), s(d);
      }, n = () => {
        Reflect.deleteProperty(w, "callback"), Reflect.deleteProperty(w, "errorCallback");
      };
      Reflect.set(w, "callback", t), Reflect.set(w, "errorCallback", i), Reflect.set(window, f, w), (y = window.turnstile) == null || y.execute(c);
    }),
    remove: () => {
      var r;
      (r = window.turnstile) == null || r.remove(Reflect.get(window, u)), Reflect.deleteProperty(window, f), Reflect.deleteProperty(window, u);
    },
    render: () => {
      var s;
      const r = (s = window.turnstile) == null ? void 0 : s.render(l.id, {
        sitekey: l.siteKey,
        appearance: "interaction-only",
        size: l.size || "normal",
        ...e,
        callback: (t) => {
          var n, y;
          console.log("token", t);
          const i = (n = Reflect.get(window, f)) == null ? void 0 : n.callback;
          console.log("this is globalCallback", i), i ? i(t) : (y = l.onSuccess) == null || y.call(l, t);
        },
        "before-interactive-callback": () => {
          var t;
          (t = l.interactiveCallback) == null || t.call(l);
        },
        "after-interactive-callback": () => {
          var t;
          (t = l.closeInteractiveCallback) == null || t.call(l);
        },
        "error-callback": (t) => {
          var n, y;
          const i = (n = Reflect.get(window, f)) == null ? void 0 : n.errorCallback;
          i ? i(t) : (y = l == null ? void 0 : l.onError) == null || y.call(l, t);
        }
      });
      Reflect.set(window, u, r);
    }
  };
  return Reflect.get(window, f) || Reflect.set(window, f, w), Reflect.set(window, u, c), c;
}
const h = class h {
  constructor() {
    I(this, "renderDialog", !1);
  }
  // 获取单例的静态方法
  static getInstance() {
    return h.instance || (h.instance = new h()), h.instance;
  }
  _createContainer(e) {
    const c = document.createElement("div");
    return e ? c.id = e : (c.style.position = "fixed", c.style.display = "flex", c.style.alignItems = "center", c.style.justifyContent = "center", c.style.visibility = "hidden", c.style.top = "0", c.style.left = "0", c.style.right = "0", c.style.bottom = "0", c.style.zIndex = "9999"), c;
  }
  /**
   * @returns Promise<string>
   *
   * @example
   * ```ts
   * loadTurnstileScript();
   * ```
   */
  async loadTurnstileScript() {
    await z("turnstile", "https://challenges.cloudflare.com/turnstile/v0/api.js");
  }
  /**
   *
   * @param options
   * @returns Promise<string>
   *
   * @example
   * ```ts
   * const token = await verifyHideTurnstile({
   *   siteKey: 'siteKey',
   *   size?:"normal",
   *   onSuccess?:(token:string)=>{},
   *   onError?:(error:any)=>{},
   *   wrapperClassname?: "turnstile-wrapper, // 挂载类名样式
   *   containerDOM?: HTMLElement | null, // 挂载的dom元素，不选择时，默认挂载在body上
   * });
   * console.log(token);
   * ```
   */
  async verifyTurnstile(e) {
    return await this.loadTurnstileScript(), new Promise(async (c, w) => {
      var r, s;
      const k = { ...e };
      if (delete k.wrapperClassname, delete k.onSuccess, delete k.onError, delete k.interactiveCallback, delete k.containerDOM, delete k.closeInteractiveCallback, delete k.onRender, this.renderDialog = !0, Reflect.get(window, u)) {
        const t = await ((r = Reflect.get(window, f)) == null ? void 0 : r.retry());
        c(t);
      } else if (!Reflect.get(window, u)) {
        const t = "turnstile-container-hide", i = "#turnstile-container-hide", n = this._createContainer(), y = this._createContainer(t);
        n.appendChild(y);
        let d = null;
        if (e != null && e.containerDOM ? (d = e == null ? void 0 : e.containerDOM, d.style.position = "relative", n.style.position = "absolute") : (d = document.querySelector("body"), d.style.position = "fixed", d.style.top = "0", d.style.left = "0", d.style.right = "0", d.style.bottom = "0", d.style.zIndex = "9999"), !d)
          throw new Error("Wrapper box not found");
        e.wrapperClassname && (n == null || n.classList.add(e.wrapperClassname)), document.querySelector(i) || d.appendChild(n);
        const S = {
          sitekey: e.siteKey,
          appearance: "execute",
          size: e.size || "normal",
          ...k,
          callback: (a) => {
            var g, m, v;
            console.log("token", a);
            const b = (g = Reflect.get(window, f)) == null ? void 0 : g.callback;
            b ? b(a) : (m = e.onSuccess) == null || m.call(e, a), c(a), n && (n.style.visibility = "hidden", (v = e == null ? void 0 : e.onRender) == null || v.call(e, !1), this.renderDialog = !1);
          },
          "before-interactive-callback": () => {
            var a, b;
            (a = e.interactiveCallback) == null || a.call(e), y.clientHeight > 0 && n && this.renderDialog && (n.style.visibility = "visible", (b = e == null ? void 0 : e.onRender) == null || b.call(e, !0));
          },
          "after-interactive-callback": () => {
            var a;
            (a = e.closeInteractiveCallback) == null || a.call(e);
          },
          "error-callback": (a) => {
            var g, m;
            const b = (g = Reflect.get(window, f)) == null ? void 0 : g.errorCallback;
            b ? b(a) : (m = e == null ? void 0 : e.onError) == null || m.call(e, a);
          }
        }, E = (s = window.turnstile) == null ? void 0 : s.render(i, S), R = {
          retry: (a) => {
            var b;
            return (b = window.turnstile) == null || b.reset(Reflect.get(window, u)), new Promise((g) => {
              const m = () => {
                Reflect.deleteProperty(R, "callback"), Reflect.deleteProperty(R, "errorCallback");
              }, v = (C) => {
                console.log("this is callback", C), m(), g(C);
              }, x = (C) => {
                var D;
                (D = a == null ? void 0 : a.onError) == null || D.call(a, C);
              };
              Reflect.set(R, "callback", v), Reflect.set(R, "errorCallback", x), Reflect.set(window, f, R), setTimeout(() => {
                var C;
                (C = window.turnstile) == null || C.execute(Reflect.get(window, u));
              }, 200);
            });
          },
          execute: () => new Promise((a, b) => {
            var x;
            const g = (C) => {
              v(), a(C);
            }, m = (C) => {
              v();
            }, v = () => {
              Reflect.deleteProperty(R, "callback"), Reflect.deleteProperty(R, "errorCallback");
            };
            Reflect.set(R, "callback", g), Reflect.set(R, "errorCallback", m), Reflect.set(window, f, R), (x = window.turnstile) == null || x.execute(E);
          }),
          remove: () => {
            var a;
            (a = window.turnstile) == null || a.remove(Reflect.get(window, u)), Reflect.deleteProperty(window, f), Reflect.deleteProperty(window, u), n && n.parentNode && n.parentNode.removeChild(n);
          },
          render: () => {
            var b;
            const a = (b = window.turnstile) == null ? void 0 : b.render(i, S);
            Reflect.set(window, u, a);
          }
        };
        Reflect.set(window, f, R), Reflect.set(window, u, E);
      }
    }).catch((c) => {
      var w;
      (w = e == null ? void 0 : e.onError) == null || w.call(e, c);
    });
  }
};
// 静态属性存储唯一实例
I(h, "instance", null);
let P = h;
const A = P.getInstance();
export {
  B as SITE_KEY_MAP,
  q as cloudflareInit,
  F as getRandomStr,
  A as humanVerify
};
